// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import DeepDiveDashboardPage from '@/features/energyxplorer/components/DeepDiveDashboardPage.tsx';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/deepdive/dashboard',
)({
  component: DeepDiveDashboardPage,
  staticData: { crumb: 'glossary:dashboard', hideEnergyAnalysisAppBar: true },
});
